import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import React from 'react'
import Login from "../pages/auth/login"
import Middleware from "../pages/Middleware"
import Dashboard from "../pages/dashboard/main-dashboard"
import ResetPassword from "../pages/auth/resetPassword"
import ViewProfile from "../pages/dashboard/view-profile"
import DetailShift from "../pages/dashboard/past-shift-detail"

const MainRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Middleware />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/support-chat" element={<Dashboard />} />
            <Route path="/view-profile" element={<ViewProfile />} />
            <Route path="/shift-detail" element={<DetailShift />} />
        </Routes>
    )
}

export default MainRoutes